import React, { Component } from 'react'
import { Header } from './Header'
import { BannerSlider } from './organisms/BannerSlider';
import { Gallery } from './organisms/Gallery';
import { Footer } from './organisms/Footer';
import OrganizerListing from '@/pages/Customer/Organizers/OrganizerListing';

/**
 * Home ("/").
 *
 * A signed-in customer taps Home to DISCOVER places — so for them Home is the venue
 * browser: the same organizer→branch listing (search, categories, pagination) reused
 * from the Explore screen, on the white app theme. From a branch they can view the
 * menu and, once checked in, order / call staff / pay (see BranchHub).
 *
 * A logged-out visitor still gets the marketing landing (banner + gallery).
 */
export class Home extends Component {
  private isAuthenticated(): boolean {
    try {
      return !!localStorage.getItem('accessToken');
    } catch {
      return false;
    }
  }

  render() {
    if (this.isAuthenticated()) {
      // OrganizerListing is a full page (its own DashboardHeader + Footer).
      return <OrganizerListing />;
    }

    return (
      <div style={{ background: '#0a0a0a', minHeight: '100vh' }}>
        <Header />
        <BannerSlider />
        <Gallery />
        <Footer />
      </div>
    )
  }
}
